import type { ClientProject } from '../../lib/clientsApi';
import { ClientProjectCard } from './ClientProjectCard';

/**
 * Client projects list (CLE-274). Each project is an expandable card that, when
 * opened, surfaces the project's meeting notes (decisions / discussion) and
 * recent task activity so the team can see at a glance what was discussed and
 * what is in progress — without leaving the client page. Tasks link to the
 * canonical task-detail route.
 */
export function ClientProjectsTab({ projects }: { projects: ClientProject[] }) {
  if (projects.length === 0) {
    return <p className="py-8 text-center text-gray-500">Niciun proiect asociat acestui client.</p>;
  }

  return (
    <div className="space-y-3">
      {projects.map((p) => (
        <ClientProjectCard key={p.id} project={p} />
      ))}
    </div>
  );
}
